import './Herosection.css';
import SpecialityMenu from './SpecialityMenu';
import VideoSection from './VideoSection';
import React from 'react';
import Herosection from './Herosection';
import AboutSection from './AboutSection';
import TrustSection from './TrustSection';
import TopDoctors from './TopDoctors';
import FamousSpecialists from './FamousSpecialists';
import Banner from './Banner';
import FAQ from './FAQ';
import HospitalMD from './HospitalMD';
import SEO from '../SEO';

function Home() {
    return (
        <React.Fragment>
            <SEO
                title="JDS Hospitals | Best Multispeciality Hospital in Visakhapatnam"
                description="JDS Hospitals, Visakhapatnam — Expert doctors, 24/7 emergency, advanced diagnostics and compassionate care since 2008. Book an appointment today."
                keywords="JDS Hospitals, best hospital Visakhapatnam, multispeciality hospital Vizag, 24/7 emergency hospital, Seethammadara hospital"
                path="/"
            />
            <Herosection />
            <AboutSection />
            <FamousSpecialists />
            <SpecialityMenu />
            <VideoSection />
            <TrustSection />
            <TopDoctors />
            <HospitalMD />
            <Banner />
            <FAQ />
        </React.Fragment>
    );
}
export default Home;